import * as axios from 'axios'
import { assembleIntercept } from './intercept'

const host = !import.meta.env.SSR ? location.origin : ''
const path = ''

// 1)实例化一个axios对象 http（根据当前环境配置baseURL）
const http = axios.create({
  baseURL: host + path,
  timeout: 10000
})

// 2）设置默认请求头的content-type
http.defaults.headers['Content-Type'] = 'application/json'

// 3) 装载拦截器
assembleIntercept(http)

export default http
